import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import { connect } from 'react-redux';
import { showModal, hideModal } from 'appSrc/redux/actions';
import { dAPI } from 'appSrc/api';
import { Icon, Table, DLMenu } from 'appSrc/components/UI';
import { CopyDrop } from '../../Common';
import { convertImage } from 'appSrc/utils';
import EditProductModal from '../../Modals/Product/EditProductModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class SortableProductsTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            productInEdit: null,
            productInEditIndex: -1,
        };
    }
    updateProduct = ( index, desireid, data ) => {
        this.props.updateProduct( desireid, data )
        .then( ( product ) => {
            return this.props.onProductUpdated && this.props.onProductUpdated( index, product );
        } );
    }
    openEditModal = ( index, product ) => {
        this.setState( { productInEdit: product, productInEditIndex: index } );
        this.props.showModal( 'editProductModal' );
    }
    onEditSubmit = ( updates ) => {
        var index = this.state.productInEditIndex;
        var oldProduct = this.state.productInEdit;
        var calls = [];
        for( var i = 0; i < updates.tags.newTags.length; i++ ) {
            var tag = updates.tags.newTags[ i ];
            calls.push( this.props.addTagToProduct( oldProduct.desireid, tag.tagtext ) );
        }
        for( var j = 0; j < updates.tags.deletedTags.length; j++ ) {
            var dTag = updates.tags.deletedTags[ j ];
            calls.push( this.props.deleteTagFromProduct( oldProduct.desireid, dTag.tagtext ) );
        }
        return Promise.all( calls )
        .then( () => {
            return this.props.updateProduct( oldProduct.desireid, updates.product );
        } )
        .then( ( updatedProduct ) => {
            this.props.onProductUpdated( index, updatedProduct );
            return updatedProduct;
        } );
    }
    onEditClose = () => {
        this.props.hideModal( 'editProductModal' );
        this.setState( { productInEdit: null, productInEditIndex: -1 } );
    }

    render() {
        const { products } = this.props;

        return (
            <div>
                <Table
                className={ style.productsTable }
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    <Table.Head>
                        <Table.Row draggable={ false }>
                            <Table.Cell></Table.Cell>
                            <Table.Cell style={ { minWidth: '100px' } }></Table.Cell>
                            <Table.Cell>PRODUCT TITLE</Table.Cell>
                            <Table.Cell>USER</Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell>ACTIONS</Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.SortableBody onChange={ this.props.onSort }>
                        { this.arrayTableRows( products ) }
                    </Table.SortableBody>
                </Table>
                { this.state.productInEdit &&
                    <EditProductModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    product={ this.state.productInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( products ) => {
        var rows = products.map( ( product, index ) => {
            var individualSlug = `/admin/products/${ product.desireid }`;
            var publicSlug = `${ window.location.origin }/app/products/${ product.desireid }/${ encodeForURI(product.title) }`;
            return (
                <Table.Row key={ product.desireid }>
                    <Table.Cell className='handle' style={ { cursor: 'grab' } }>
                        <Icon source='fontAwesome' icon='fas/faArrowsAltV' style={ { color: 'inheirit' } } />
                    </Table.Cell>
                    <Table.Cell className={ style.coverImage }>
                        <Link to={ individualSlug }></Link>
                        <img src={ convertImage( product.image, '/100x100' ) } style={ { height: '80px' } } />
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ individualSlug }></Link>
                        { product.title }
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <Link to={ individualSlug }></Link>
                        { product.author.displayName }
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <CopyDrop content={ publicSlug } />
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, product );
                            } }/>
                            <DLMenu.Item text={ product.deactivated ? 'Activate' : 'Deactivate' }
                            onClick={ () => {
                                this.updateProduct( index, product.desireid, {
                                    deactivated: !product.deactivated,
                                    title: product.title,
                                } );
                            } }/>
                            <DLMenu.Item text={ product.featured ? 'Unfeature' : 'Feature' }
                            onClick={ () => {
                                this.updateProduct( index, product.desireid, {
                                    featured: !product.featured,
                                    title: product.title,
                                } );
                            } }/>
                        </DLMenu>
                    </Table.Cell>
                </Table.Row>
            );
        } );

        return rows;
    }
}
SortableProductsTable.defaultProps = {
    onProductUpdated: ()=>{},
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        updateProduct: ( desireid, data ) => {
            return dAPI.patch( `/desires/${ desireid }`, dAPI.clean.product( data ) );

        },
        addTagToProduct: ( desireid, newTag ) => {
            return dAPI.post( `/desires/${ desireid }/tag`, { tag: newTag } );

        },
        deleteTagFromProduct: ( desireid, tagtext ) => {
            return dAPI.delete( `/desires/${ desireid }/tag/${ tagtext }` );

        },
    };
};

export default connect( null, mapDispatchToProps )( SortableProductsTable );
